import Nullstack from 'nullstack';
export default function IconCastOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cast-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 19h.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 19a4 4 0 0 0 -4 -4"
  }), "   ", Nullstack.element("path", {
    d: "M11 19a8 8 0 0 0 -8 -8"
  }), "   ", Nullstack.element("path", {
    d: "M15 19h3a3 3 0 0 0 .875 -.13m1.997 -2.002a3 3 0 0 0 .128 -.868v-8a3 3 0 0 0 -3 -3h-9m-3.865 .136a3 3 0 0 0 -1.935 1.864"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}